import React from 'react';

const works = [
  {
    title: "Waterproofing",
    description: "We provide expert waterproofing solutions to protect your property from water damage, using high-quality materials and proven techniques.",
  },
  {
    title: "Rebaring",
    description: "Rebaring is the process of adding steel bars to a structure during changes in the plan or expansion, enhancing structural integrity and durability.",
  },
  {
    title: "Grouting",
    description: "We offer professional grouting services to fill voids and stabilize your structures, enhancing durability and longevity.",
  },
  {
    title: "Water Tank Waterproofing",
    description: "Specialized in water tank waterproofing, we ensure your tanks are protected against leaks, ensuring safe water storage.",
  },
];

const Works = () => {
  return (
    <div className="works-page" id='work1'>
        <div className="container">
      <header className="header">
        <h1>Our services</h1>
      </header>
      <section className="works">
        {works.map((work, index) => (
          <div className="work-item" key={index}>
            <h2 className="reason-title">{work.title}</h2>
            <p className="description">{work.description}</p>
          </div>
        ))}
      </section>
      </div>
    </div>
  );
};

export default Works;
